var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.state.token)?_c('div',{staticClass:"submit-form",on:{"click":_vm.submit}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }